import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, List, Button, Icon } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { isValidArray } from '../../../utilities/validations';
import { CTA } from '../../../';

import './index.css';

const TopNav = ({ navTitle, linksArray, ctaButton, children, className, ...other }) => {
	const [showLinks, setShowLinks] = useState(false);
	const [activeLink, setActiveLink] = useState('Jump to..');

	if (!isValidArray(linksArray)) return null;

	const onTriggerClick = () => setShowLinks(!showLinks);

	const onLinkClick = (title) => {
		if (title) setActiveLink(title);
		setShowLinks(false);
	};

	return (
		<div
			className={`topNav sticky top-[59px] z-[19] w-full bg-black py-2 duration-300 sm:top-[63px] xl:top-[98px] 2xl:py-0 ${className || ''}`}
			{...other}
		>
			<Container className='md:max-3xl:!px-4 3xl:!pr-0'>
				<div className={`md:flex md:flex-row md:flex-wrap md:items-center md:gap-x-8 2xl:items-stretch`}>
					{navTitle && (
						<div className='topNav-title mb-3 flex flex-row text-sm font-semibold uppercase text-white md:mb-0 md:flex-[0_0_188px] lg:flex-[0_0_220px] lg:text-base 2xl:flex-col 2xl:justify-center 2xl:py-2 [&_span]:block'>
							<div
								className='flex-1'
								dangerouslySetInnerHTML={{ __html: navTitle }}
							/>
						</div>
					)}

					<div className='relative sm:max-w-[290px] sm:flex-1 2xl:flex 2xl:max-w-full'>
						<Button
							color='primary-alt'
							className='topNav-button !flex flex-row items-center justify-between border-2 border-white !p-2 !text-white max-2xl:mx-auto max-2xl:!pl-3 2xl:!hidden'
							size='sm'
							onClick={onTriggerClick}
							wide
						>
							<span
								className='topNav-buttonText flex flex-1 items-center text-left'
								dangerouslySetInnerHTML={{ __html: activeLink }}
							/>

							<Icon
								name='arrow_drop_down'
								className='ml-2 flex-none'
								size={30}
							/>
						</Button>

						<List
							bullets='none'
							className={`topNav-links max-2xl:space-y-4 max-2xl:border-2 max-2xl:border-t-0 max-2xl:border-white max-2xl:bg-black max-2xl:px-4 max-2xl:py-4 md:absolute md:left-0 md:top-full md:max-2xl:w-full 2xl:static 2xl:flex-1 2xl:space-x-8 ${showLinks ? 'max-2xl:block' : 'max-2xl:hidden'}`}
							layout='inline'
						>
							{linksArray.map((link, index) => {
								const ctaClasses = classNames({
									'!flex h-full items-center font-semibold text-white transition-colors hover:opacity-100 max-2xl:uppercase 2xl:normal-case 2xl:border-y-4 2xl:border-t-transparent 2xl:py-3 2xl:hover:border-b-primary xl:text-base': true,
									'2xl:border-b-primary 2xl:!no-underline topNav-activeLink': activeLink === link.link.title,
									'!no-underline 2xl:border-b-transparent hover:!opacity-100': activeLink !== link.link.title,
								});

								return (
									<li
										key={index}
										className='max-2xl:max-w-full max-2xl:!flex-12/12 lg:text-base 2xl:text-sm'
									>
										<CTA
											data={link}
											className={ctaClasses}
											onClick={() => onLinkClick(link.link.title)}
										/>
									</li>
								);
							})}
						</List>
					</div>

					{children && (
						<div
							data-testid='localnav-children'
							className='flex items-center py-4 md:py-0 2xl:flex-none'
						>
							{children}
						</div>
					)}
				</div>
			</Container>
		</div>
	);
};

TopNav.propTypes = {
	navTitle: PropTypes.any,
	linksArray: PropTypes.array.isRequired,
	ctaButton: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default TopNav;
